import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsYaMetrikaLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './SettingsYaMetrikaDefault')
);

export const SettingsYaMetrikaAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsYaMetrikaLazy />
    </DelayedSuspense>
);
